
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  if (!window.REACT_APP_NAVIGATE) {
    const navigate = useNavigate();
    useEffect(() => {
      window.REACT_APP_NAVIGATE = navigate;
      navigateResolver(window.REACT_APP_NAVIGATE);
      
      // ページ遷移後にページトップに瞬間移動
      const originalNavigate = navigate;
      window.REACT_APP_NAVIGATE = (path: string | number, options?: any) => {
        if (typeof path === 'string') {
          originalNavigate(path, options);
          // スクロールではなく瞬間的に先頭に移動
          window.scrollTo(0, 0);
        } else {
          originalNavigate(path);
        }
      };
    });
  }
  return element;
}
